import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const DomainsPage = lazy(() => import('./pages/DomainsPage'));

export const DomainsRoutes: RouteObject = {
  path: 'domains',
  children: [
    { path: '', element: <DomainsPage />, handle: { crumb: 'Domains, TLS & SEO' } },
  ],
};
